module.exports = __webpack_public_path__ + "img/mastercard-platinum.79d6e4f2.png";